import React from 'react'

import General from '../../utils/General'
import Backend from '../../utils/Backend'
import RequestScheduler from '../../utils/RequestScheduler'


export default class Block extends React.Component {

  updateContentBlockScheduler = new RequestScheduler.LatestWins(Backend.updateContentBlock);

  updateContentBlock = General.debounce(() => {
    let data = JSON.parse(JSON.stringify(this.state.data))
    if(data.forms){
      let formIds = data.forms.map(form => {
        return form.id
      })
      data.forms = formIds
    }
    if(data.product_category){
      data.product_category = data.product_category ? data.product_category.id : null
    }
    this.updateContentBlockScheduler.schedule(data)
  }, 1000, false)

}
